module.exports = __webpack_public_path__ + "img/solution.ef0f48a5.png";